/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import { AxiosInstance, AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {}

export interface IRequestConfig {
    method?: any;
    headers?: any;
    url?: any;
    data?: any;
    params?: any;
}

// Add options interface
export interface ServiceOptions {
    axios?: AxiosInstance;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
    if (serviceOptions.axios) {
        return serviceOptions.axios
            .request(configs)
            .then((res) => {
                resolve(res.data);
            })
            .catch((err) => {
                reject(err);
            });
    } else {
        throw new Error('please inject yourself instance like axios  ');
    }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
    const configs: IRequestConfig = { ...options, method, url };
    configs.headers = {
        ...options.headers,
        'Content-Type': contentType,
    };
    return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
    [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
    items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
    items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
    totalCount?: number;
    items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
    totalCount?: number;
    items?: T[];
}

// customer definition
// empty

export class BankService {
    /**
     *
     */
    static runOneIntegration(
        params: {
            /** requestBody */
            body?: BankIntegrationDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/bank/run-one-integration';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    /**
     * Сопоставление и стыковка Банковских операции и счетов
     */
    static linkOperationToInvoice(
        params: {
            /** requestBody */
            body?: LinkOperationToInvoiceDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<Array<{ [key: string]: any }>> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/bank/link-invoice';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
}

export class RulePickerService {
    /**
     *
     */
    static introspectChangesForRules(
        params: {
            /** requestBody */
            body?: IntrospectChangesDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<object[]> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/rule-picker/introspect';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
}

export class AuthService {
    /**
     *
     */
    static getAuthLink(
        params: {
            /** requestBody */
            body?: GetLinkDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/authorization/get-link';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static onCodeObtained(
        params: {
            /** requestBody */
            body?: OnCodeObtainedDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/authorization/on-code-obtained';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
}

export class DocGenerationService {
    /**
     *
     */
    static generateDocument(
        params: {
            /** requestBody */
            body?: DocGenerationDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/document-generation';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static documentCreateBasedOn(
        params: {
            /** requestBody */
            body?: DocGenerationBasedOnDataDto;
        } = {} as any,
        options: IRequestOptions = {}
    ): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/document-create-based-on';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = params.body;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
    /**
     *
     */
    static generateDocsFromFile(options: IRequestOptions = {}): Promise<any> {
        return new Promise((resolve, reject) => {
            let url = basePath + '/generation-docs';

            const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

            let data = null;

            configs.data = data;
            axios(configs, resolve, reject);
        });
    }
}

export interface BankIntegrationDto {
    /**  */
    bankIntegrationId: string;
}

export interface LinkOperationToInvoiceDto {
    /**  */
    operation_period_start: number;

    /**  */
    operation_period_end: number;

    /**  */
    invoice_period_start: number;

    /**  */
    invoice_period_end: number;

    /**  */
    org_account_id: string;

    /** */
    statuses: string[];
}

export interface IntrospectChangesDto {
    /**  */
    ruleIds?: string[];
}

export interface GetLinkDto {
    /**  */
    type: EnumGetLinkDtoType;

    /**  */
    company: object;

    /**  */
    state: string;
}

export interface OnCodeObtainedDto {
    /**  */
    state: string;

    /**  */
    type: EnumOnCodeObtainedDtoType;

    /**  */
    code: string;

    /**  */
    org_id: string;

    /**  */
    account_id: string;
}

export interface DocGenerationDto {
    /**  */
    file: string;

    /**  */
    reportTemplate: object;

    /**  */
    sysParams: object;

    /**  */
    apiKey: string;

    /**  */
    extension: object;

    /**  */
    json?: string;

    /**  */
    data: object;
}

export interface DocGenerationBasedOnDataDto {
    /**  */
    sysParams: object;

    /**  */
    documentBaseType: EnumDocGenerationBasedOnDataDtoDocumentBaseType;

    /**  */
    documentCreatedType: EnumDocGenerationBasedOnDataDtoDocumentCreatedType;

    /**  */
    authorEmployee: object;

    /**  */
    data: object;

    /**  */
    saveDoc: boolean;
}
export enum EnumGetLinkDtoType {
    'TINKOFF' = 'TINKOFF',
    'TOCHKA' = 'TOCHKA',
    'ALFA' = 'ALFA',
}
export enum EnumOnCodeObtainedDtoType {
    'TINKOFF' = 'TINKOFF',
    'TOCHKA' = 'TOCHKA',
    'ALFA' = 'ALFA',
}
export enum EnumDocGenerationBasedOnDataDtoDocumentBaseType {
    'INVOICE' = 'INVOICE',
    'ACT' = 'ACT',
    'CONTRACT' = 'CONTRACT',
    'PAYMENT_REGISTER' = 'PAYMENT_REGISTER',
    'OTHER' = 'OTHER',
}
export enum EnumDocGenerationBasedOnDataDtoDocumentCreatedType {
    'INVOICE' = 'INVOICE',
    'ACT' = 'ACT',
    'CONTRACT' = 'CONTRACT',
    'PAYMENT_REGISTER' = 'PAYMENT_REGISTER',
    'OTHER' = 'OTHER',
}
